import { render, staticRenderFns } from "./foss.vue?vue&type=template&id=7f9a6b3a&scoped=true"
import script from "./foss.vue?vue&type=script&lang=js"
export * from "./foss.vue?vue&type=script&lang=js"
import style0 from "./foss.vue?vue&type=style&index=0&id=7f9a6b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9a6b3a",
  null
  
)

export default component.exports